import './chatbot/sass/virtual-agent.scss';
import 'platform/polyfills';

import startApp from 'platform/startup';

import manifest from './manifest.json';
import routes from './chatbot/routes';
import { chatbotReducer } from './chatbot/store';
import { initLogging } from './chatbot/utils/logging';

initLogging();

startApp({
  entryName: manifest.entryName,
  url: manifest.rootUrl,
  reducer: { chatbot: chatbotReducer },
  routes,
});
